import React from 'react';
import { motion } from 'framer-motion';
const team = [{
  id: 1,
  name: 'Dr. Alejandro Voss',
  role: 'Director Clínico & Implantología',
  img: 'https://images.unsplash.com/photo-1622253692010-333f2da6031d?w=800&q=80'
}, {
  id: 2,
  name: 'Dra. Valentina Reyes',
  role: 'Especialista en Estética Dental',
  img: 'https://cdn.magicpatterns.com/uploads/h1ufnKqhogF4TYRDNLa73a/Imagen_1.png'
}, {
  id: 3,
  name: 'Dr. Marcus Chen',
  role: 'Ortodoncia Digital Avanzada',
  img: 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=800&q=80'
}];
export function Team() {
  return <section id="equipo" className="py-24 bg-ivory relative z-20" data-id="element-105" data-mp="1if0on61181ut">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-106" data-mp="1mgdtpdwaw10o">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-center mb-16" data-id="element-107" data-mp="1mdrnpip25tkk">
          <h2 className="font-serif text-4xl md:text-5xl text-ink mb-4" data-id="element-108" data-mp="1hpxi9mqn0iye">
            Nuestro <span className="text-gold-deep italic" data-id="element-109" data-mp="1ctffutis4wp8">Equipo</span>
          </h2>
          <p className="font-sans text-ink-soft max-w-2xl mx-auto" data-id="element-110" data-mp="17uvuovc0foxx">
            Profesionales de renombre internacional dedicados a la excelencia y
            el arte de la odontología moderna.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10" data-id="element-111" data-mp="20j9r56ngad7d">
          {team.map((member, index) => <motion.div key={member.id} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.08,
          ease: [0.23, 1, 0.32, 1]
        }} className="group" data-id="element-112" data-mp="1vli0efyjkx4r" data-mpi={index}>
              <div className="relative overflow-hidden rounded-sm aspect-[3/4] mb-6 border border-line bg-surface" data-id="element-113" data-mp="2tcwue0co5a3b">
                <img src={member.img} alt={member.name} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700" data-id="element-114" data-mp="2ybrdz4ign2oh" />
                <div className="absolute inset-0 border-2 border-transparent group-hover:border-gold/60 transition-colors duration-300" data-id="element-115" data-mp="2oemz7pqy29hp" />
              </div>
              <div className="text-center" data-id="element-116" data-mp="2fl9xbyawjxjh">
                <h3 className="font-serif text-2xl text-ink mb-1" data-id="element-117" data-mp="2fmb9y77kgs3b">
                  {member.name}
                </h3>
                <p className="font-sans text-gold-deep text-sm uppercase tracking-widest" data-id="element-118" data-mp="20p0wwtf9ze5h">
                  {member.role}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}